var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"EconomyExpenses"},[_vm._v(" Gastos ")])
}
var staticRenderFns = []

export { render, staticRenderFns }